import { defineComponent as _defineComponent } from 'vue'
interface Props {
	/**
	 * 表示するHTML。
	 */
	html: string | null;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    html: { type: [String, null], required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * 表示するHTML。
	 */
	html: string | null;
}
/**
 * 上部HTML。
 */



const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})